import React, { useState, useEffect } from 'react';
import {
  Box, Typography, CircularProgress, List, ListItemButton,
  ListItemAvatar, ListItemText, Avatar, Chip, TextField, InputAdornment
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import PersonIcon from '@mui/icons-material/Person';
import supabase from '../../../supabaseClient';

function WorkerReportList({ idConfig, onSelect }) {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading]     = useState(false);
  const [search, setSearch]       = useState('');

  useEffect(() => {
    if (!idConfig) return;
    const fetch = async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from('employees')
        .select('id, name, surname, hourly_rate, position, contract_type, archived')
        .eq('id_configuration', idConfig)
        .order('surname');
      setLoading(false);
      if (error) { console.log(error); } else setEmployees(data || []);
    };
    fetch();
  }, [idConfig]);

  const filtered = employees.filter(e =>
    `${e.name} ${e.surname}`.toLowerCase().includes(search.toLowerCase())
  );

  if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}><CircularProgress /></Box>;

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>Wybierz pracownika</Typography>
      <TextField
        fullWidth size="small" placeholder="Szukaj pracownika..."
        value={search} onChange={e => setSearch(e.target.value)}
        InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }}
        sx={{ mb: 2 }}
      />
      <List disablePadding>
        {filtered.map(emp => (
          <ListItemButton key={emp.id} onClick={() => onSelect(emp)}
            sx={{ borderRadius: 2, mb: 0.5, border: '1px solid', borderColor: 'divider' }}>
            <ListItemAvatar>
              <Avatar sx={{ bgcolor: 'primary.light', width: 36, height: 36, fontSize: '0.85rem' }}>
                {emp.name?.[0]}{emp.surname?.[0]}
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={`${emp.name} ${emp.surname}`}
              secondary={`${emp.position ?? 'Pracownik'} · ${emp.hourly_rate?.toFixed(2) ?? '—'} zł/h`}
            />
            <Chip
              label={emp.archived ? 'Nieaktywny' : 'Aktywny'}
              size="small"
              color={emp.archived ? 'default' : 'success'}
              variant="outlined"
            />
          </ListItemButton>
        ))}
        {filtered.length === 0 && (
          <Typography sx={{ color: 'text.secondary', py: 3, textAlign: 'center' }}>
            Brak pracowników
          </Typography>
        )}
      </List>
    </Box>
  );
}

export default WorkerReportList;
